import Button from "react-bootstrap/Button";
import Select from "react-select";

const handleKeyPress = (e) => {
  if (e.charCode === 45 || e.charCode === 46) {
    e.preventDefault();
  }
};

// 🔹 Función para formatear números con puntos como separador de miles
const formatNumber = (num) => {
  if (!num || isNaN(num)) return "";
  return Number(num).toLocaleString("de-DE");
};

function TableRows({ rowsData, deleteTableRows, handleChange, handleChange2, listcostos, handleChangeSelect }) {
  return (
    rowsData.map((data, index) => {
      const { descuento, precio, iva, total } = data;

      return (
        <tbody key={index}>
          <tr>
            <td>
              <input
                type="number"
                min="0"
                onKeyPress={handleKeyPress}
                onChange={(evnt) => handleChange2(index, evnt)}
                name="descuento"
                className="form-control"
                value={descuento || ""}
              />
            </td>
            <td>
              <input
                type="number"
                min="1"
                onKeyPress={handleKeyPress}
                onChange={(evnt) => handleChange(index, evnt)}
                name="cantidad"
                className="form-control"
                value={data.cantidad || ""}
              />
            </td>
            <td>
              <Select
                className="mt-2"
                options={listcostos}
                name="producto"
                onChange={(evnt) => handleChangeSelect(index, evnt, "producto")}
              />
            </td>
            <td>
              <input
                type="text"
                name="precio"
                className="form-control"
                value={formatNumber(precio)}
                disabled
              />
            </td>
            <td>
              <input
                type="text"
                name="ivaproducto"
                className="form-control"
                value={formatNumber(iva)}
                disabled
              />
            </td>
            <td>
              <input
                type="text"
                name="total"
                className="form-control"
                value={formatNumber(total)}
                disabled
              />
            </td>
            <td>
              <Button
                size="sm"
                variant="danger"
                onClick={() => deleteTableRows(index)}
              >
                x
              </Button>
            </td>
          </tr>
        </tbody>
      );
    })
  );
}

export default TableRows;
